import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-modify-solar',
  templateUrl: './modify-solar.component.html',
  styleUrls: ['./modify-solar.component.scss']
})
export class ModifySolarComponent implements OnInit {
  @ViewChild('queryDataTable', { static: true })
  public queryDataTable: Table;
  
  public userId: any;
  public text: any;
  public password: any;

  public textDefinition: any = null;

  constructor(
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }


  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));   
    // console.log('token1', token);
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
  }

  onSubmit() {
    if(this.text == null || this.text == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please write text.',
      });
      return;
    }
    if(this.password == null || this.password == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please Enter Password.',
      });
      return;
    }
    let reqBody = {
      text: this.cryptoJsService.Encrypt(this.text),
      userId: this.userId ? this.cryptoJsService.Encrypt(this.userId) : '',
      passCode: this.cryptoJsService.Encrypt(this.password)
    }
    this.postQuery(reqBody);
  }


  postQuery(reqBody){
    this.loader.start();
    this.apiService
      .modifySolarFlow(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.text = null;
          this.password = null;
          this.textDefinition = data;
        },
        error: (err) => {
          this.loader.close();
          this.textDefinition = null;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }


}
